'use client'

import React from 'react'
import { Box, Heading, Text, Button, VStack, HStack, AlertIcon } from '@chakra-ui/react'
import { css } from '@emotion/react'
import customTheme from '../../constants/theme'
import { FolderFilled } from '../chakra/icons/FolderFilled'
import { WarningIcon } from '@chakra-ui/icons'
import { Link } from '../chakra/Link'

const NotFoundPage = () => {
  return (
    <Box
      css={css`
        background-color: ${customTheme.colors.background.dark};
        min-height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${customTheme.colors.text.dark};
        font-family: ${customTheme.fonts.body};
      `}
    >
      <VStack spacing={8} align="center">
        <HStack
          css={css`
            position: relative;
          `}
          spacing={4}
        >
          <FolderFilled
            css={css`
              width: 64px;
              height: 64px;
              color: ${customTheme.colors.primary.base};
            `}
          />
          <WarningIcon
            css={css`
              width: 30px;
              height: 30px;
              position: absolute;
              top: 0;
              right: 0;
              color: ${customTheme.colors.custom.lightGray};
            `}
          />
        </HStack>
        <Heading
          as="h1"
          size="2xl"
          css={css`
            color: ${customTheme.colors.text.dark};
          `}
        >
          404 - Folder Not Found
        </Heading>
        <Text
          fontSize="xl"
          css={css`
            color: ${customTheme.colors.text.accentedGray};
          `}
        >
          Oops! The folder you're looking for doesn't exist.
        </Text>
        <Link href="/">
          <Button
            css={css`
              background-color: ${customTheme.colors.primaryButton[500]};
              color: ${customTheme.colors.text.dark};
              transition: background-color ${customTheme.transition.duration.normalSlow};
              &:hover {
                background-color: ${customTheme.colors.primaryButton[600]};
              }
              &:active {
                background-color: ${customTheme.colors.primaryButton[700]};
              }
            `}
          >
            Go Back Home
          </Button>
        </Link>
      </VStack>
    </Box>
  )
}

export default NotFoundPage
